import { z } from 'zod'

export const INT32_MIN = -2147483648
export const INT32_MAX = 2147483647
export const MAX_SCORE_BANDS = 50

export const int32Schema = z.number().int().min(INT32_MIN).max(INT32_MAX)

export const scoreBandSchema = z.object({
  bandId: z.uuid(),
  min: int32Schema,
  max: int32Schema,
  label: z.string().trim().min(1).max(255),
  description: z.string().max(500).nullable().optional(),
})

export const scoreBandsSchema = z.array(scoreBandSchema).min(1).max(MAX_SCORE_BANDS)

export const resultPropertyMappingSchema = z.record(z.string(), z.string().min(1).max(255))

export type ScoreBand = z.infer<typeof scoreBandSchema>
export type ResultPropertyMapping = z.infer<typeof resultPropertyMappingSchema>
